import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useIntl } from '@atlassian/jira-intl';
import { useMappingState } from '../../../controllers/import-state';
import messages from './messages';
import { boldElement, useValidationErrors } from './utils';

export const ValidationError = () => {
	const { formatMessage } = useIntl();
	const [mappingState] = useMappingState();
	const { columnErrors, missingErrors, count } = useValidationErrors(mappingState);

	return (
		<Box xcss={sectionWrapperStyles}>
			<SectionMessage
				testId="project-create-importer-upload-flow.ui.mapping-screen.validation-error.section-message"
				appearance="error"
				title={formatMessage(messages.titleStandard, { count })}
			>
				<Box xcss={contentStyles}>
					<Box as="ol" xcss={listStyle}>
						{missingErrors.map((message, index) => (
							<Box as="li" key={index}>
								{message}
							</Box>
						))}
						{columnErrors.length > 0 && (
							<Box as="li">
								{formatMessage(messages.formattingErrorHeading, { b: boldElement })}
								<Box as="ol" xcss={sublistStyle}>
									{columnErrors.map((column) => (
										<Box as="li" key={column}>
											<Box as="b">{column}</Box>
										</Box>
									))}
								</Box>
							</Box>
						)}
					</Box>
				</Box>
			</SectionMessage>
		</Box>
	);
};

const contentStyles = xcss({
	maxHeight: '10vh',
	overflowY: 'auto',
});

const listStyle = xcss({
	paddingLeft: 'space.200',
});

const sublistStyle = xcss({
	paddingLeft: 'space.200',
	listStyleType: 'lower-alpha',
});

const sectionWrapperStyles = xcss({
	marginBottom: 'space.300',
});
